<template>
  <div class="duoSession">
    <LocalParticipant />
    <RemoteParticipant @rebootWithNewSessionID="rebootWithNewSessionID" />
  </div>
</template>

<script>
import LocalParticipant from "./SessionComponents/LocalParticipant";
import RemoteParticipant from "./SessionComponents/RemoteParticipant";

export default {
  name: "DuoSession",
  props: {
    sessionID: String,
  },
  components: {
    LocalParticipant,
    RemoteParticipant,
  },
  methods: {
    rebootWithNewSessionID(SID) {
      this.$emit("rebootWithNewSessionID", SID);
    },
  },
};
</script>

<style>
@import "./SessionStyles/DuoSession.css";
</style>
